import automationHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/automations-header.png';
import automationSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/automations-section1.png';
import automationSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/automations-section2.png';
import automationSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/automations-section3.png';
import alertsHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/alerts-header.png';
import alertsSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section1.png';
import alertsSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section2.png';
import alertsSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/alerts-section3.png';
import dedupeHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-header.png';
import dedupeSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section1.png';
import dedupeSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section2.png';
import dedupeSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/dedupe-section3.png';
import routingHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/routing-header.png';
import routingSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/routing-section1.png';
import routingSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/routing-section2.png';
import routingSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/routing-section3.png';
import reportsHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/reports-header.png';
import reportsSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/reports-section1.png';
import reportsSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/reports-section2.png';
import reportsSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/reports-section3.png';
import hubspotHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-header.png';
import hubspotSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section1.png';
import hubspotSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section2.png';
import hubspotSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/hubspot-section3.png';
import aiHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/ai-header.png';
import aiSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/ai-section1.png';
import aiSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/ai-section2.png';
import aiSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/ai-section3.png';
import documentationHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/documentation-header.png';
import documentationSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section1.png';
import documentationSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section2.png';
import documentationSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section3.png';
import rollupsHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/rollups-header.png';
import rollupsSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section1.png';
import rollupsSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section2.png';
import rollupsSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section3.png';
import changeFeedHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-header.png';
import changeFeedSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section1.png';
import changeFeedSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section2.png';
import changeFeedSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section3.png';
import funnelsHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/funnels-header.png';
import funnelsSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section1.png';
import funnelsSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section2.png';
import funnelsSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/funnels-section3.png';
import devopsHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/devops-header.png';
import devopsSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/devops-section1.png';
import devopsSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/devops-section2.png';
import devopsSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/devops-section3.png';
import agenticHeader from '../components/dashboard/paywall/sales-activated-trial/page/images/agentic-header.png';
import agenticSection1 from '../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section1.png';
import agenticSection2 from '../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section2.png';
import agenticSection3 from '../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section3.png';
import agenticSection4 from '../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section4.png';
import { PageblockData } from './pageblockTypes';

export const MONITORING_PAGEBLOCK_TEXT = `Supports Salesforce Admins and Architects by continuously scanning for risks, technical debt, and violations, enabling teams to stay proactive and focus on high-impact work.`
export const PROCESS_PAGEBLOCK_TEXT = `Stop bottlenecks before they happen. Sweep's Process Agent combine the expertise of RevOps, analysts, and Salesforce architects into one AI solution to clear the way for growth.`
export const DOCUMENTATION_PAGEBLOCK_TEXT = `Proactively capture, organize, and maintain system knowledge, freeing your team from manual context gathering and updates.`

export const PAGEBLOCK_DATA_AUTOMATIONS: PageblockData = {
  headerData: {
    headerText: 'Build custom Salesforce automations ',
    subHeaderText:
      'Create no-code, native Salesforce automations to streamline your team’s workflows.',
    imgSrc: automationHeader,
    imgAlt: 'Automations header',
    name: 'Automations',
  },
  pageTitle: 'Unlock seamless automation for complex workflows in Salesforce',
  section1: {
    imgSrc: automationSection1,
    imgAlt: 'Automations section img',
    title: 'Record creation & updates',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
  section2: {
    imgSrc: automationSection2,
    imgAlt: 'Automations section 2 img',
    title: 'Process orchestration',
    content:
      'Automate complex, multi-step workflows with conditional logic and tasks assignments to ensure consistent and efficient process execution.',
  },
  section3: {
    imgSrc: automationSection3,
    imgAlt: 'Automations section 3 img',
    title: 'Execute third party integrations',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
};
export const PAGEBLOCK_DATA_DOCUMENTATION: PageblockData = {
  headerData: {
    headerText: 'Document your Salesforce org in real-time effortlessly',
    subHeaderText:
      'Create up-to-date, AI-powered documentation with clear metadata descriptions and comprehensive dependency mapping for seamless org management.',
    imgSrc: documentationHeader,
    imgAlt: 'Documentation header',
    name: 'Documentation',
  },
  pageTitle: 'Optimize Salesforce management with AI-powered documentation',
  section1: {
    imgSrc: documentationSection1,
    imgAlt: 'Documentation section img',
    title: 'Real-time documentation of your Salesforce org',
    content:
      'Automatically generate up-to-date documentation of your Salesforce environment, ensuring accurate and current records of your configurations.',
  },
  section2: {
    imgSrc: documentationSection2,
    imgAlt: 'Documentation section 2 img',
    title: 'AI-generated descriptions of your metadata',
    content:
      'Leverage AI to create clear and comprehensive descriptions for all metadata components, enhancing understanding and management of your Salesforce setup.',
  },
  section3: {
    imgSrc: documentationSection3,
    imgAlt: 'Documentation section 3 img',
    title: 'Org-wide dependency mapping',
    content:
      'Visualize and analyze dependencies across your entire Salesforce org to better understand relationships and impacts within your configurations.',
  },
};
export const PAGEBLOCK_DATA_SF_CHANGE_FEED: PageblockData = {
  headerData: {
    headerText: 'Stay ahead with real-time change tracking for your Salesforce org',
    subHeaderText:
      'Monitor every change, receive instant alerts for updates, and gain a unified view of all modifications across your Salesforce environments.',
    imgSrc: changeFeedHeader,
    imgAlt: 'Change feed header img',
    name: 'Change Feed',
  },
  pageTitle: `Achieve complete visibility and control with Sweep´s Salesforce change feed`,
  section1: {
    imgSrc: changeFeedSection1,
    imgAlt: 'Change feed section img',
    title: 'Track changes made in your Salesforce org, forever',
    content:
      'Monitor and record every modification within your Salesforce environment in real-time, ensuring a permanent and comprehensive audit trail.',
  },
  section2: {
    imgSrc: changeFeedSection2,
    imgAlt: 'Change feed section 2 img',
    title: 'Alerts for unwanted changes',
    content:
      'Receive immediate notifications for critical or unauthorized updates, enabling prompt response to potential issues.',
  },
  section3: {
    imgSrc: changeFeedSection3,
    imgAlt: 'Change feed section 3 img',
    title: 'Track across all your orgs in one place',
    content:
      'Consolidate change tracking across multiple Salesforce organizations into a single, unified view for streamlined oversight.',
  },
};
export const PAGEBLOCK_DATA_FUNNEL_MAPS: PageblockData = {
  headerData: {
    headerText: 'Create new business processes with funnel editor',
    subHeaderText:
      'Design, optimize, and manage your business workflows with an intuitive and collaborative visual funnel editor.',
    imgSrc: funnelsHeader,
    imgAlt: 'Funnels header img',
    name: 'Funnels',
  },
  pageTitle: `Optimize and collaborate on your customer journey with Sweep's visual funnel editor`,
  section1: {
    imgSrc: funnelsSection1,
    imgAlt: 'Funnels section img',
    title: 'Full visualization of your customer journey',
    content:
      'Gain a comprehensive visual representation of your entire customer journey, allowing for better analysis and optimization of each stage.',
  },
  section2: {
    imgSrc: funnelsSection2,
    imgAlt: 'Funnels section 2 img',
    title: 'Business context into automations and validations',
    content:
      'Incorporate business context seamlessly into your automations and validations, ensuring that your processes align with organizational objectives.',
  },
  section3: {
    imgSrc: funnelsSection3,
    imgAlt: 'Funnels section 3 img',
    title: 'Collaborate with teammates',
    content:
      'Work collaboratively with your team in real-time within the Funnel Editor, enhancing efficiency and ensuring alignment across departments.',
  },
};
export const PAGEBLOCK_DATA_ROLLUPS: PageblockData = {
  headerData: {
    headerText: 'Simplify data aggregation with scalable rollups',
    subHeaderText:
      'Create up-to-date, AI-powered documentation with clear metadata descriptions and comprehensive dependency mapping for seamless org management.',
    imgSrc: rollupsHeader,
    imgAlt: 'Rollups header',
    name: 'Rollups',
  },
  pageTitle: 'Optimize Salesforce management with AI-powered documentation',
  section1: {
    imgSrc: rollupsSection1,
    imgAlt: 'Rollups section img',
    title: 'Rollup data from any relationship',
    content:
      'Effortlessly aggregate data across both master-detail and lookup relationships within Salesforce, eliminating mid-configuration frustration.',
  },
  section2: {
    imgSrc: rollupsSection2,
    imgAlt: 'Rollups section 2 img',
    title: 'Scalable architecture – no CPU timeouts',
    content:
      'Benefit from a robust architecture designed to handle large data volumes efficiently, ensuring rollup processes complete without CPU timeouts.',
  },
  section3: {
    imgSrc: rollupsSection3,
    imgAlt: 'Rollups section 3 img',
    title: 'Use rollups to trigger automation',
    content:
      'Leverage rollup fields to initiate automated workflows and processes throughout your Salesforce organization, enhancing operational efficiency.',
  },
};
export const PAGEBLOCK_DATA_ALERTS: PageblockData = {
  headerData: {
    headerText: 'Set up seamless Salesforce & Slack integration',
    subHeaderText:
      'Connect your team to the revenue process with real-time Salesforce updates directly in Slack.',
    imgSrc: alertsHeader,
    imgAlt: 'Alerts header',
    name: 'Alerts',
  },
  pageTitle: 'Turn key pipeline events into actionable alerts',
  section1: {
    imgSrc: alertsSection1,
    imgAlt: 'Alerts section img',
    title: 'Custom alerts & notifications',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
  section2: {
    imgSrc: alertsSection2,
    imgAlt: 'Alerts section 2 img',
    title: 'Update Salesforce directly from Slack',
    content:
      'Enable your team to update Salesforce directly from Slack, turning notifications into actionable tasks without leaving the platform.',
  },
  section3: {
    imgSrc: alertsSection3,
    imgAlt: 'Alerts section 3 img',
    title: 'Automate deal room creation & updates',
    content:
      'Automate the creation and updates of deal rooms in Slack based on key events to keep your team aligned and up-to-date.',
  },
};
export const PAGEBLOCK_DATA_DEDUP: PageblockData = {
  headerData: {
    headerText: 'Simplify data management with automated deduplication',
    subHeaderText:
      'Eliminate duplicates and ensure your Salesforce data stays accurate and consistent.',
    imgSrc: dedupeHeader,
    imgAlt: 'Dedupe header',
    name: 'Dedupe & Matching',
  },
  pageTitle: 'Keep your data clean with deduplication and matching',
  section1: {
    imgSrc: dedupeSection1,
    imgAlt: 'Dedupe section img',
    title: 'Customize your deduplication logic',
    content:
      'Configure custom deduplication rules with advanced filters, tie-breakers, and timing control to support your data needs.',
  },
  section2: {
    imgSrc: dedupeSection2,
    imgAlt: 'Dedupe section 2 img',
    title: 'Auto-merge duplicates across Salesforce objects',
    content:
      'Automatically identify and merge duplicate records—such as leads, contacts, and accounts—across Salesforce objects, ensuring clean and consistent data.',
  },
  section3: {
    imgSrc: dedupeSection3,
    imgAlt: 'Dedupe section 3 img',
    title: 'Native matching for any Salesforce object',
    content:
      'No more manually matching leads to accounts. Automate this process and ensure new leads are accurately linked to existing accounts.',
  },
};
export const PAGEBLOCK_DATA_ROUTING: PageblockData = {
  headerData: {
    headerText: 'Boost pipeline speed with automated assignment & routing',
    subHeaderText:
      'Create and manage groups, territories, and assignment rules for any Salesforce object.',
    imgSrc: routingHeader,
    imgAlt: 'Routing header',
    name: 'Routing',
  },
  pageTitle: 'Effortlessly assign leads and opportunities with smart routing',
  section1: {
    imgSrc: routingSection1,
    imgAlt: 'Routing section img',
    title: 'Customizable assignment logic',
    content:
      'Create custom assignment rules tailored to any scenario, ensuring leads, opportunities, and other records connect with the right person based on your specific Salesforce setup.',
  },
  section2: {
    imgSrc: routingSection2,
    imgAlt: 'Routing section 2 img',
    title: 'Optimize territory & group management',
    content:
      'Define territories, teams, and workload limits to balance assignments efficiently. Quickly adjust rules based on evolving sales strategies, ensuring fair distribution across geographies, roles, or custom criteria.',
  },
  section3: {
    imgSrc: routingSection3,
    imgAlt: 'Routing section 3 img',
    title: 'Automate record assignment for faster routing',
    content:
      'Ensure every record reaches the right team member instantly using customizable routing criteria, round robin distribution, and scheduled assignments—reducing manual effort and improving response times.',
  },
};
export const PAGEBLOCK_DATA_REPORTS: PageblockData = {
  headerData: {
    headerText: 'Access real-time insights with Salesforce reporting',
    subHeaderText:
      'Make data-driven decisions with advanced reporting and real-time dashboards that streamline your workflows and boost sales performance.',
    imgSrc: reportsHeader,
    imgAlt: 'Reports header',
    name: 'Reports',
  },
  pageTitle: 'Track key sales metrics & boost pipeline performance',
  section1: {
    imgSrc: reportsSection1,
    imgAlt: 'Reports section img',
    title: 'Improve funnel conversion',
    content:
      'Gain a clear understanding of your conversion rates across your sales funnels. Identify areas for improvement so you can optimize your process and boost your pipeline predictability.',
  },
  section2: {
    imgSrc: reportsSection2,
    imgAlt: 'Reports section 2 img',
    title: 'Track velocity across all funnels',
    content:
      'Track the velocity of records through the different steps of a deal to identify bottlenecks and opportunities for optimization',
  },
  section3: {
    imgSrc: reportsSection3,
    imgAlt: 'Reports section 3 img',
    title: 'Automatically update reports with funnel changes',
    content:
      'Experience dynamic reporting that adjusts in real-time with changes to your sales funnels, eliminating the need to manually rebuild reports.',
  },
};
export const PAGEBLOCK_DATA_DEVOPS_CENTER: PageblockData = {
  headerData: {
    headerText: 'Easily compare & deploy Sweep elements',
    subHeaderText:
      'Take full control of your Sweep configurations by seamlessly managing deployments across Sandbox, Production, and other Salesforce  environments.',
    imgSrc: devopsHeader,
    imgAlt: 'Devops header',
    name: 'Compare & Deploy',
  },
  pageTitle: 'See what’s been deployed to any of your Salesforce environments',
  section1: {
    imgSrc: devopsSection1,
    imgAlt: 'Devops section img',
    title: 'Track Sweep elements across environments',
    content:
      'Gain a clear, side-by-side view of all deployed Sweep elements—including automations, lead routing rules, assignment logic, and more. Instantly identify differences and ensure consistency between environments.',
  },
  section2: {
    imgSrc: devopsSection2,
    imgAlt: 'Devops section 2 img',
    title: 'Deploy with confidence',
    content:
      'Compare versions of Sweep elements and identify changes before deploying. Whether you need to update a single rule, a set of automations, or a full process, you can deploy with precision and ease.',
  },
  section3: {
    imgSrc: devopsSection3,
    imgAlt: 'Devops section 3 img',
    title: 'Simplify Sweep deployment & version management',
    content:
      'Ensure every Sweep configuration is properly deployed across environments. Streamline updates, prevent misconfigurations, and maintain a smooth, reliable deployment process with built-in comparison and deployment tools.',
  },
};
export const PAGEBLOCK_DATA_MARKETING: PageblockData = {
  headerData: {
    headerText: 'Automate HubSpot-to-Salesforce Campaign Syncing',
    subHeaderText:
      'Visualize and manage campaign workflows across platforms, ensuring both HubSpot and Salesforce stay in sync for complete marketing attribution.',
    imgSrc: hubspotHeader,
    imgAlt: 'Hubspot header',
    name: 'Hubspot',
  },
  pageTitle: 'Bridge the gap between marketing and sales with seamless campaign attribution',
  section1: {
    imgSrc: hubspotSection1,
    imgAlt: 'Hubspot section img',
    title: 'Manage campaigns between Salesforce and HubSpot in one place',
    content:
      'Prevent duplicate records, mismatched campaign data, and attribution gaps by ensuring marketing and sales operate with a single, accurate source of truth.',
  },
  section2: {
    imgSrc: hubspotSection2,
    imgAlt: 'Hubspot section 2 img',
    title: 'Automate campaign enrollment & syncing',
    content:
      'Define automated rules in HubSpot to instantly sync contacts into Salesforce campaigns, eliminating manual effort and keeping systems aligned.',
  },
  section3: {
    imgSrc: hubspotSection3,
    imgAlt: 'Hubspot section 3 img',
    title: 'Unify marketing attribution reporting',
    content:
      'Combine HubSpot and Salesforce data into a single source of truth, creating reports that show the true ROI of your marketing campaigns.',
  },
};
export const PAGEBLOCK_DATA_AI_ASSISTANT: PageblockData = {
  headerData: {
    headerText: 'Transform end user support with AI',
    subHeaderText:
      'Respond faster, reduce time spent on support, and provide end users with a seamless experience. Automate routine tasks and deliver real-time answers directly within Salesforce.',
    imgSrc: aiHeader,
    imgAlt: 'AI header',
    name: 'AI Assistant',
  },
  pageTitle: 'Empower end user self-service with Salesforce support AI assistant',
  section1: {
    imgSrc: aiSection1,
    imgAlt: 'AI section img',
    title: 'Easily troubleshoot Salesforce issues',
    content:
      'End users can quickly copy and paste error messages into the chat for instant troubleshooting, with the option to escalate to an admin if needed.',
  },
  section2: {
    imgSrc: aiSection2,
    imgAlt: 'AI section 2 img',
    title: 'Automate ticket creation and sync with your system',
    content:
      'Create and sync support ticket from within Salesforce, ensuring integration with your existing support workflows.',
  },
  section3: {
    imgSrc: aiSection3,
    imgAlt: 'AI section 3 img',
    title: 'AI-powered, admin-reviewed support',
    content:
      'Users can ask the AI-powered "Virtual Admin" questions, and all conversations are recorded for your review, giving you control and insight into the process.',
  },
};
export const PAGEBLOCK_DATA_AGENTIC_LAYER: PageblockData = {
  headerData: {
    headerText: `Scalable systems, powered by agents`,
    subHeaderText: `Harness the power of AI agents, a dynamic visual workspace, and automated workflows. Automate processes, enforce data quality, and drive execution, all in one intelligent system.`,
    imgSrc: agenticHeader,
    imgAlt: 'Agentic Layer header',
    name: 'Agentic Layer',
  },
  pageTitle: `Stay ahead in the agentic era`,
  section1: {
    imgSrc: agenticSection1,
    imgAlt: 'Agentic Layer section img',
    title: 'Monitoring Agent',
    content: MONITORING_PAGEBLOCK_TEXT,
  },
  section2: {
    imgSrc: agenticSection2,
    imgAlt: 'Agentic Layer section 2 img',
    title: 'Process Agent',
    content: PROCESS_PAGEBLOCK_TEXT,
  },
  section3: {
    imgSrc: agenticSection3,
    imgAlt: 'Agentic Layer section 3 img',
    title: 'User Support Agent',
    content: `Reduces the time your Salesforce admin and revenue operations teams spend on support, improving SLAs and delivering a better, happier user experience.`,
  },
  section4: {
    imgSrc: agenticSection4,
    imgAlt: 'Agentic Layer section 4 img',
    title: 'Documentation Agent',
    content: DOCUMENTATION_PAGEBLOCK_TEXT,
  },
};
